@if (menuEntry$ | async; as menu) {
    @if (menu.mainMenu?.length || menu.aboutMenu?.length) {
        <nav
            #menuBarContainer
            [attr.role]="'navigation'"
            i18n-aria-label="@@hermes.accessibility.navigation_menu"
            aria-label="Navigation menu"
            (mouseleave)="onMouseLeave()"
            (keydown.arrowleft)="focusLeft()"
            (keydown.arrowright)="focusRight()"
            (keydown.home)="setFocusToFistItem()"
            (keydown.end)="setFocusToLastItem()">
            <ul
                class="menu-bar-container"
                [ngStyle]="{
                    '--header-menu-height.px': headerMenuHeight,
                }">
                @for (subMenuEntry of menu.mainMenu; track subMenuEntry; let index = $index) {
                    <li class="item">
                        <h-menu-parent-category
                            [menuEntry]="subMenuEntry"
                            [focused]="parentCategoryFocusedIndex() === index"
                            [onCursorLeaveMenuBar$]="mousLeaveEventsSubject"
                            (keydown)="onKeyDown($event, index)"
                            (keyup)="onKeyUp($event)"
                            [isFirstCategory]="index === 0"
                            [isLastCategory]="lastCategoryHasOpenSubMenu()"></h-menu-parent-category>
                    </li>
                }
                @if (menu.mainMenu?.length && menu.aboutMenu?.length) {
                    <li aria-hidden="true" class="menu-separator"></li>
                }
                @for (subMenuEntry of menu.aboutMenu; track subMenuEntry; let index = $index) {
                    <li class="item">
                        <h-menu-parent-category
                            [menuAboutEntry]="subMenuEntry"
                            [focused]="parentCategoryFocusedIndex() === index"
                            [onCursorLeaveMenuBar$]="mousLeaveEventsSubject"
                            (keydown)="onKeyDown($event, index)"
                            (keyup)="onKeyUp($event)"
                            [isFirstCategory]="index === 0"
                            [isLastCategory]="lastCategoryHasOpenSubMenu()"></h-menu-parent-category>
                    </li>
                }
            </ul>
        </nav>
    }
}
